// extracted by mini-css-extract-plugin
export default {"root":"ConfettiContainer-module__root"};